import { createContext } from 'react';

/** The station whose sheet is open, and where it was opened from. */
export type SelectedSite = {
  id: string;
  origin: 'list' | 'map';
};

export type SiteLookupMapContextProps = {
  /** station row under the pointer or focus in the list: its map pin is highlighted */
  hoveredSiteId: string | null;
  isMapExtended: boolean;
  toggleIsMapExtended: () => void;
  setHoveredSiteId: (id: string | null) => void;
  setIsMapExtended: (value: boolean) => void;
  selectedSite: SelectedSite | null;
  setSelectedSite: (value: SelectedSite | null) => void;
};

export const defaultSiteLookupMapContext: SiteLookupMapContextProps = {
  hoveredSiteId: null,
  isMapExtended: false,
  toggleIsMapExtended: () => {},
  setHoveredSiteId: () => {},
  setIsMapExtended: () => {},
  selectedSite: null,
  setSelectedSite: () => {},
};

const SiteLookupMapContext = createContext<SiteLookupMapContextProps>(defaultSiteLookupMapContext);

export default SiteLookupMapContext;
